import React from 'react';
import { DeleteOutlined, HeartOutlined } from '@ant-design/icons';

import PriceTag from '../../../components/shared/PriceTag';
import ConditionBadge from '../../../components/shared/ConditionBadge';

import {
  CartItemCard,
  ItemImage,
  ItemDetails,
  ItemTitle,
  ItemAuthor,
  ItemSeller,
  ItemMeta,
  ItemActions,
  ActionButton,
  ItemPriceArea,
} from '../styles';

export default function CartItem({ item, onRemove, onSaveForLater }) {
  return (
    <CartItemCard>
      <ItemImage>
        {item.coverImage && <img src={item.coverImage} alt={item.bookTitle} />}
      </ItemImage>
      <ItemDetails>
        <ItemTitle to={`/libro/${item.listingId}`}>{item.bookTitle}</ItemTitle>
        <ItemAuthor>{item.authorName}</ItemAuthor>
        <ItemSeller>Vendido por {item.sellerName || 'Vendedor'}</ItemSeller>
        <ItemMeta>
          <ConditionBadge condition={item.condition} />
        </ItemMeta>
        <ItemActions>
          <ActionButton type="button" onClick={onSaveForLater}>
            <HeartOutlined />
            Guardar para después
          </ActionButton>
          <ActionButton type="button" $variant="danger" onClick={onRemove}>
            <DeleteOutlined />
            Eliminar
          </ActionButton>
        </ItemActions>
      </ItemDetails>
      <ItemPriceArea>
        <PriceTag amount={item.price} originalAmount={item.originalPrice} />
      </ItemPriceArea>
    </CartItemCard>
  );
}
